import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorCorrectionHeaderApproval = () => {
  const { t } = useTranslation()
  const correctionHeaderApproval = useCallback(
    (payload) => {
      const uidTransaction = payload.transaction_uid
      delete payload.transaction_uid
      ApiService.jsonRequest('/transaction-correction-header/approval', payload, (response) => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message:
              payload.status === 'APPROVED'
                ? t('response_message.correction_approve_success')
                : t('response_message.correction_reject_success'),
            timer: 2000,
            redirect: `/order/correction?uid=${uidTransaction}`,
          })
        } else {
          showAlert({
            icon: 'warning',
            message:
              payload.status === 'APPROVED'
                ? t('response_message.correction_approve_failed')
                : t('response_message.correction_reject_failed'),
            timer: 2000,
            redirect: `/order/correction?uid=${uidTransaction}`,
          })
        }
      })
    },
    [t],
  )
  return { correctionHeaderApproval }
}

export default InteractorCorrectionHeaderApproval
